import VideoPlayer from '@components/VideoPlayer';
import type { FC } from 'react';
import { observer } from 'mobx-react';
import { Modal } from '@ui';
import { useStores } from '@root/src/stores';

const VideoModal: FC = observer(() => {
  const { modalsStore } = useStores();
  const { videoModal, closeVideoModal } = modalsStore;

  if (!videoModal?.url) {
    return null;
  }

  return (
    <Modal
      crossOutside
      closeClassName='sm:-top-9 sm:-right-1 md:fromMd:-top-8 md:fromMd:-right-8'
      onClose={closeVideoModal}
    >
      <div className='flex flex-col items-center justify-center'>
        <VideoPlayer
          isModal
          url={videoModal.url}
          isDesktop={videoModal.isDesktop}
          isTablet={videoModal.isTablet}
        />
      </div>
    </Modal>
  );
});

export default VideoModal;
